import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { Box, Grid, FormControl,
  InputLabel,
  Select,
  MenuItem,
  // Button,
  TextField} from "@mui/material";
import { useEditTeam } from "../../Hooks";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import { Formik, Form } from "formik";
import { ReactComponent as AddTeamVector } from "../../StaticData/Vectors/addTeamVector.svg";
import { useGetAllActivePersonByTenantId } from "../../Hooks";
import { useSelector } from "react-redux";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
// import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useGetTeamDetail } from "../../Hooks";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import CustomeMultiSelect from "../../../OKRManagment/new/customeMultiSelect";
import { editTeamSchema } from "../../StaticData";
import { ErrorMessage } from "formik";
import "../RegisterTenant/Error.css";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import { useGetAllObjectiveDefinitionLevelByTenantId } from "../../../OKRManagment/Hooks";
// setShowToastMessage={setShowToastMessage}
// setAddTeamState={setTeamAsyncOpState}
const EditTeam = (props: any) => {
  let { loading, onClose, setShowToastMessage, setEditTeamState } = props;
  // const [teamId, setTeamId] = useState<string | null>(null);
  const [editTeamsinintialValues, setEditTeamsInitialValues] =
    useState<any>(null);
  // const tenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
  const tenantId: any = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const { data: activePersonData, isLoading: getActivePersonLoading } =
    useGetAllActivePersonByTenantId(tenantId);
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const {
    data: teamDetailData,
    isLoading: getTeamDetailLoading,
    isFetched: getTeamDetailFetched,
  } = useGetTeamDetail(props?.teamId);

  const {
    mutate: callEditTeam,
    data: editTeamData,
    isSuccess,
    isError,
  } = useEditTeam();

  const { data: teamsOptions, isLoading: teamOPloading } =
  useGetAllObjectiveDefinitionLevelByTenantId(tenantId);

  const [personIdData, setPersonIdData] = useState([]);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [teamPersons, setTeamPersons] = useState<any[]>([]);
  const [parentId, setParentId] = useState<string>('');
  const [showLToastMessage, setLShowToastMessage] = useState<boolean>(false);
  const [teamAsynOpcState, setTeamAsyncOpState] = useState<any>(null);
  const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);

  const [allTeamAndPersonBaseData, setAllTeamAndPersonBaseData] = useState<any>(
    []
  );

  const [teamName, setTeamName] = useState<any>({
      teamName: null,
    });

  useEffect(() => {
    if (teamDetailData) {
      let { name, managerId, personQueryResultDtos, id , parentId}: any = teamDetailData;
      let initValue = {
        name: name,
        managerId: managerId,
        id: id,
        parentId : parentId,
        tenantId: tenantId,
        fromDate: "",
        toDate: null,
        lastModifiedById: userId,
        PersonIds: personQueryResultDtos?.map(({ id }: any) => id),
      };
      setParentId(initValue.parentId);
      setTeamPersons(
        personQueryResultDtos?.map((item: any) => {
          let { id: year, name: title } = item;
          return { year, title };
        })
      );
      setEditTeamsInitialValues(initValue);
    }
  }, [teamDetailData]);

  useEffect(() => {
    if (activePersonData && teamDetailData) {
      let localArray: any[] = [];
      activePersonData.map((activePerson: any) =>
        teamDetailData.personQueryResultDtos.findIndex(
          (item: any) => item.id === activePerson.value
        ) > -1
          ? localArray.push({
              id: activePerson.value,
              name: activePerson.key,
              checked: true,
            })
          : localArray.push({
              id: activePerson.value,
              name: activePerson.key,
              checked: false,
            })
      );
      setAllTeamAndPersonBaseData(localArray);
    }
  }, [activePersonData, teamDetailData]);

  useEffect(() => {
    if (editTeamData){
      if (editTeamData?.data.isSuccess) {
        setShowToastMessage(true);
        setEditTeamState(editTeamData?.data);
        onClose(false);
      }else {
        SetIsSuccess(false);
        SetTMessage(editTeamData?.data.metaData.message);
        setShowLtoastMessage(true);
      }
    }
  }, [editTeamData, isSuccess]);

  useEffect(() => {
    const localArray: any[] = [];
    setPersonIdData(
      activePersonData?.map((item: any) => {
        let { key, value } = item;
        const isChecked: boolean = false;
        return { year: value, title: key };
      })
    );
  }, [activePersonData]);

  useEffect(() => {
    if (isError) {
      setLShowToastMessage(true);

    }
  }, [isError, editTeamData]);

  const initialSubmitForm = (data: any) => {
    let selectedMembers: string[] = [];
    allTeamAndPersonBaseData.map(
      (item: any) => item.checked && selectedMembers.push(item.id)
    );
    const teamDataLocal = { ...data, personIds: [...selectedMembers] };
    callEditTeam(teamDataLocal);
  };

  if (getTeamDetailLoading) {
    return (
      <Box py={4} textAlign={"center"}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container style={{ overflow: "inherit" }}>
      <Grid item xs={12}>
        <Box width={"100%"} textAlign={"center"}>
          <AddTeamVector style={{ width: "350px", height: "150px" }} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        {!getTeamDetailLoading == true ? (
          <Formik
            enableReinitialize
            validationSchema={editTeamSchema}
            initialValues={editTeamsinintialValues}
            onSubmit={(data: any) => {
              initialSubmitForm(data);
            }}
          >
            {({
              values,
              setFieldValue,
              dirty,
              isValid,
              touched,
              errors,
              setFieldTouched,
            }) => (
              <Form>
                <Grid
                  container
                  columnSpacing={1}
                  sx={{
                    bgcolor: "background.paper",
                    mx: "auto",
                    borderRadius: 3,
                  }}
                >
                  <Grid item xs={12}>
                    <Box sx={{ padding: "8px" }}>
                    <div className="error">
                    <ErrorMessage name="name" />
                  </div>
                      <TextField
                        size="small"
                        name="name"
                        fullWidth
                        label={"نام"}
                        value={values?.name || ""}
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("name", value);
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                   {
                    parentId !== null && parentId !== '' ?
                    <Box sx={{ padding: "16px" }}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">
                        والد
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-selectd"
                        value={values?.parentId || ""}
                        label="والد"
                        onChange={(e: any, other: any) => {
                          let { props } = other;

                          let {
                            children: keyName,
                            content,
                            value: propsValue,
                          } = props;
                          setTeamName((prev: any) => ({
                            ...prev,
                            teamName: keyName,
                          }));
                          // if (!content) {
                          //   setObjNameIds((prev: any) => ({
                          //     ...prev,
                          //     definitionLevelId: propsValue,
                          //   }));
                          // }
                          // setDefinitionLevel(keyName)
                          let { target } = e;
                          let { value } = target;
                          // setTeameIdObjects((prev:teamIdsFace)=>({...prev,teamId:value}))
                          setFieldValue("parentId", value);
                        }}
                      >
                        {teamOPloading && (
                          <Box width={"100%"} textAlign={"center"}>
                            <DyLoadingCircular />
                          </Box>
                        )}

                        {teamsOptions &&
                          teamsOptions.map((item: any) => {
                            let { key, value, isCompany } = item;
                            return (
                              <MenuItem
                                key={key}
                                value={value}
                                content={isCompany}
                              >
                                {key}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Box>
                  :
                  <></>
                   }
                  </Grid>

                  <Grid item xs={12} md={12}>
                  <div className="error">
                    <ErrorMessage name="managerId" />
                  </div>
                    <FormikControl
                      control="select"
                      options={activePersonData || []}
                      label="مدیر"
                      name="managerId"
                      fullWidth
                      value={values?.managerId || ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                  <div className='error'>
                    <ErrorMessage name="personIds" />
                    </div>
                    {/* <MultiSelect
                      initialValues={teamPersons || []}
                      options={personIdData || []}
                      isLoading={getActivePersonLoading}
                      onChangee={setFieldValue}
                      propName="personIds"
                      label={"انتخاب اعضا"}
                    /> */}
                    
                    <div className=" relative cursor-pointer px-2">
                      <div
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                          e.preventDefault();
                          setShowMultiSelect(!showMultiSelect);
                        }}
                        className={` px-2 w-full py-2 mt-1 flex justify-between text-xs font-thin text-black 
                            
                              rounded-md  ml-3 border-2 ${
                                showMultiSelect
                                  ? "border-sky-600"
                                  : "border-slate-200"
                              }   `}
                      >
                        انتخاب اعضا
                        {showMultiSelect ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )}
                      </div>

                      {showMultiSelect && allTeamAndPersonBaseData && (
                        <div className="absolute w-[98%] top-full right-0">
                          <CustomeMultiSelect
                            data={allTeamAndPersonBaseData}
                            setShowMultiSelect={setShowMultiSelect}
                            title="انتخاب اعضا"
                            setCheckBoxes={(id: string) => {
                              let tmpData: any = allTeamAndPersonBaseData.map(
                                (item: any) =>
                                  item.id === id
                                    ? {
                                        ...item,
                                        checked: !item.checked,
                                      }
                                    : { ...item }
                              );
                              setAllTeamAndPersonBaseData(tmpData);
                            }}
                          ></CustomeMultiSelect>
                        </div>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} mt={1}>
                    <Box
                      px={1}
                      columnGap={2}
                      display={"flex"}
                      justifyContent={"center"}
                      flexDirection={"row-reverse"}
                    >
                      <Box>
                        <DyButton
                          caption={"ذخیره"}
                          color={"#00387C"}
                          onClick={() => {}}
                          disbled={!dirty || !isValid || !values?.name}
                          variant={"contained"}
                          bgColor={"#00387C"}
                          type={"submit"}
                        />
                      </Box>

                      <Box>
                        <DyButton
                          caption={"انصراف"}
                          variant={"outlined"}
                          onClick={() => {
                            onClose(false);
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : (
          ""
        )}
      </Grid>

      {showLToastMessage && (
        <DYToastMessage
          isSuccess={teamAsynOpcState?.isSuccess}
          message={teamAsynOpcState?.metaData.message}
          setShow={setShowToastMessage}
          show={showLToastMessage}
        />
      )}
      {showLtoastMessage && (
        <DYToastMessage
          isSuccess={isSucces}
          message={tMessage}
          setShow={setShowLtoastMessage}
          show={showLtoastMessage}
        />
      )}
    </Grid>
  );
};

export default EditTeam;
